import { Registration } from "@p0security/shared/integrations/types";

import { AwsSqsComponents } from "./components.ts";

export const AwsSqsIconUrl =
  "https://upload.wikimedia.org/wikipedia/commons/7/7e/AWS_Simple_Icons_Messaging_Amazon_SQS.svg";

export const AwsSqsRegistration = Registration({
  category: "other",
  components: AwsSqsComponents,
  docs: {},
  itemKind: "queue",
  label: "Amazon SQS",
  logoUrl: AwsSqsIconUrl,
  maturity: "beta",
});
